import React, { Component } from 'react'
import PropTypes from 'prop-types'

class RiderDeleteModal extends Component {
  render() {
    return (
      <div className="modal-content">
        <div className="form">
          <p className="center">Are you sure you want to delete <i>{this.props.title}</i> ?</p>

          <button className="btn-danger" onClick={() => this.props.deleteRider()}>Yes, delete rider</button>
        </div>
      </div>
    )
  }
}

RiderDeleteModal.propTypes = {
  title: PropTypes.string,
  deleteRider: PropTypes.func,
  setModal: PropTypes.func
}

RiderDeleteModal.defaultProps = {
  title: 'This rider',
  deleteRider: function() {},
  setModal: function() {}
}

export default RiderDeleteModal



// WEBPACK FOOTER //
// ./src/components/modals/rider-delete-modal.js